<template>
  <div class=company-reply>
    <div class="module-item-style reply-filter">
      <el-select v-model="category" placeholder="请选择" class="select-type" @change="filterList">
        <el-option
            label="全部企业回复分类"
            value="">
        </el-option>
        <el-option
            v-for="item in categoryList"
            :key="item.id"
            :label="item.groupName"
            :value="item.id">
        </el-option>
      </el-select>
      <el-input placeholder="请输入回复快捷词" v-model="searchProblem" class="input-search-problem">
        <el-button slot="append" icon="el-icon-search" @click="filterList"></el-button>
      </el-input>
    </div>
    <div class="module-item-style">
      <tableMulti
          :tableData="tableData"
          :tableHead="tableHead"
          :tableHandler="tableHandler"
          :total="total"
          :size="pageSize"
          @handleButton="handleOperate"
          @pageHandler="pageOperate"></tableMulti>
    </div>
  </div>
</template>

<script>
  import tableMulti from '@/components/table/table-multi'

  export default {
    name: "company-reply",
    components: {
      tableMulti
    },
    data() {
      return {
        category: '',
        categoryList: [],
        searchProblem: '',
        currentPage: 1,
        pageSize: 10,
        tableHandler: [
          {label: "编辑", type: 'edit', methods: 'editMethods'},
          {label: "删除", type: 'del', methods: 'delMethods'},
        ],
        tableData: [],
        tableHead: [
          {
            label: '快捷词',
            value: 'title',
            operate: false
          }, {
            label: '分类',
            value: 'groupTypeStr',
            operate: false
          }, {
            label: '回复内容',
            value: 'content',
            operate: false
          }, {
            label: '操作',
            value: '',
            width: '160',
            operate: true,
          }
        ],
        total: 0
      }
    },
    created() {
      this.getCompanyCategoryList()
    },
    mounted() {
      eventBus.$on('reloadCompanyReply', () => {
        this.getReplyDetail()
      })
      eventBus.$on('reloadCompanyCategoryReply', () => {
        this.getCompanyCategoryList()
      })
    },
    methods: {
      /**
       * 表单操作
       * @param val
       */
      handleOperate(val) {
        console.log(val)
        let delData = []
        if (val.methods == "delMethods") {
          this.delreplyContent(val.row.qrId)
        } else if (val.methods == 'delAll') {
          if (val.row.length == 0) {
            this.$message({
              showClose: true,
              message: '请勾选要删除的二维码名片',
              type: 'error',
              duration: 3 * 1000
            })
            return false
          }
          val.row.map((item) => {
            delData.push(item.qrId)
          })
          this.delSomeReplyContent(delData)
        } else if (val.methods == 'editMethods') {
          eventBus.$emit('editQuickReply', val.row)
        }
        // this.delFile(delData)
      },
      /**
       *  分页操作
       * @param val
       */
      pageOperate(val) {
        if (val.type == 'currentChange') {
          this.currentPage = val.val
        } else if (val.type == "sizeChange") {
          this.pageSize = val.val
        }
        this.getReplyDetail()
      },
      /**
       * 筛选
       */
      filterList() {
        this.currentPage = 1
        this.getReplyDetail()
      },
      getCompanyCategoryList() {
        this.$http.getCategoryListAPI({
          type: '2',
          pageSize: 500,
          pageNum: 1,
        }).then(res => {
          if (res.status == 1) {
            if (res.data.list.length > 0) {
              this.categoryList = res.data.list
              // this.category = res.data.list[0].id
              eventBus.$emit('companyCategory', this.categoryList)
              this.getReplyDetail()
            }

          }
        })
      },
      getReplyDetail() {
        this.$http.ReplyContentDetailAPI({
          groupId: this.category,
          pageNum: this.currentPage,
          pageSize: this.pageSize,
          groupContent: this.searchProblem,
          type: 2,
        }).then(res => {
          if (res.status == 1) {
            let subData = res.data
            this.categoryList.map(item => {
              subData.map(subItem => {
                if (item.id == subItem.groupId) {
                  subItem.groupTypeStr = item.groupName
                }
                subItem.contentInitialData = subItem.content
                  this.$nextTick( () => {
                      subItem.content = this.$utils.u_RenderContent(subItem.content)
                      subItem.content = subItem.content.replace(/<.*?>/g, "")
                      subItem.content = subItem.content.replace(/&nbsp;/ig, "")
                  })


                // const newVal = val.replace(/<(?!img).*?>/g,"") // 去除img以外的标签
              })
            })
            this.tableData = subData
            this.total = res.total
          } else {
            this.tableData = []
            this.total = 0
          }
        })
      },
      delreplyContent(replayId) {
        this.$http.delReplyContentAPI({
          replayId
        }).then(res => {
          if (res.status == 1) {
            this.getReplyDetail()
            this.$message({
              message: res.msg,
              type: 'success',
            })
          } else {
            this.$message({
              message: res.msg,
              type: 'error',
            })
          }
        })
      },
      delSomeReplyContent(data) {
        this.$http.delSomeReplyContentAPI({
          replayIds: data
        }).then(res => {
          if (res.status == 1) {
            this.getReplyDetail()
            this.$message({
              message: res.msg,
              type: 'success',
            })
          } else {
            this.$message({
              message: res.msg,
              type: 'error',
            })
          }
        })
      }
    },
  }
</script>

<style lang="scss">
  .company-reply {
    .reply-filter {
      display: flex;

      .input-search-problem {
        width: 300px;
        margin-left: 20px;
      }
    }
  }
</style>